import gql from "graphql-tag";

export const FETCH_DEPOSIT = gql`
  query FetchDeposit($depositId: String!) {
    data: fetchDeposit(depositId: $depositId) {
      alert {
        type
        message
      }
      payload
    }
  }
`;

export const INITIATE_DEPOSIT = gql`
  mutation InitiateDeposit($depositAmount: Float!) {
    data: initiateDeposit(depositAmount: $depositAmount) {
      alert {
        type
        message
      }
      payload
    }
  }
`;

export const VERIFY_DEPOSIT = gql`
  mutation VerifyDeposit($reference: String!, $currenyId: String!) {
    data: verifyDeposit(reference: $reference, currenyId: $currenyId) {
      alert {
        type
        message
      }
      payload
    }
  }
`;

export const REPORT_DEPOSIT = gql`
  mutation ReportDeposit($message: String!, $depositId: String!) {
    data: reportDeposit(message: $message, depositId: $depositId) {
      alert {
        type
        message
      }
      payload
    }
  }
`;
